import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withModifiers as _withModifiers, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "over"
};
const _hoisted_2 = {
  class: "tags-view-container"
};
const _hoisted_3 = {
  class: "scrollView"
};
const _hoisted_4 = ["onClick", "onContextmenu"];
import ContextMenu from './ContextMenu.vue';
import { ref, reactive, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const scrollbarRef = ref();
    function handleScroll(e) {
      const wheelDelta = e.wheelDelta || -e.deltaY * 40;
      scrollbarRef.value.setScrollLeft(scrollbarRef.value.wrapRef.scrollLeft - wheelDelta);
    }
    /**
     * 是否被选中
     */
    const isActive = tag => {
      return tag.path === route.path;
    };

    /**
     * 关闭 tag 的点击事件
     */
    const store = useStore();
    const onCloseClick = index => {
      store.commit('app/removeTagsView', {
        type: 'index',
        index: index
      });
    };

    // contextMenu 相关
    const selectIndex = ref(0);
    const visible = ref(false);
    const menuStyle = reactive({
      left: 0,
      top: 0
    });
    /**
     * 展示 menu
     */
    const openMenu = (e, index) => {
      const {
        x,
        y
      } = e;
      menuStyle.left = x + 'px';
      menuStyle.top = y + 'px';
      selectIndex.value = index;
      visible.value = true;
    };

    /**
     * 关闭 menu
     */
    const closeMenu = () => {
      visible.value = false;
    };

    /**
     * 监听变化
     */
    watch(visible, val => {
      if (val) {
        document.body.addEventListener('click', closeMenu);
      } else {
        document.body.removeEventListener('click', closeMenu);
      }
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_scrollbar, {
        class: "tags-view-wrapper",
        ref_key: "scrollbarRef",
        ref: scrollbarRef,
        onWheel: _withModifiers(handleScroll, ["prevent"])
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.tagsViewList, (tag, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["tags-view-item", isActive(tag) ? 'active' : '']),
            style: _normalizeStyle({
              backgroundColor: isActive(tag) ? _ctx.$store.getters.cssVar.menuBg : '',
              borderColor: isActive(tag) ? _ctx.$store.getters.cssVar.menuBg : ''
            }),
            key: tag.fullPath,
            onClick: $event => _ctx.$router.push(tag.fullPath),
            onContextmenu: _withModifiers($event => openMenu($event, index), ["prevent"])
          }, [_createTextVNode(_toDisplayString(tag.title) + " ", 1), _withDirectives(_createVNode(_component_svg_icon, {
            icon: "close",
            onClick: _withModifiers($event => onCloseClick(index), ["prevent", "stop"])
          }, null, 8, ["onClick"]), [[_vShow, !isActive(tag)]])], 46, _hoisted_4);
        }), 128))])]),
        _: 1
      }, 512), _withDirectives(_createVNode(ContextMenu, {
        style: _normalizeStyle(menuStyle),
        index: selectIndex.value
      }, null, 8, ["style", "index"]), [[_vShow, visible.value]])])]);
    };
  }
};